'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const publish = (name, data) => {
    if (!window.Shopify?.analytics?.publish) return;
    try {
      const result = window.Shopify.analytics.publish(`comfort_next:${name}`, data);
      if (result?.catch) result.catch(() => {});
    } catch (_) {}
  };
  const collectionSort = document.querySelector('.cn-collection-sort');
  if (collectionSort) collectionSort.addEventListener('submit', () => {
    publish('collection_sort_applied', {
      collection: location.pathname.split('/').pop(),
      sort_by: collectionSort.querySelector('[name="sort_by"]').value
    });
  });
  const fitLinkTracking = document.getElementById('cn-fit-link');
  if (fitLinkTracking) fitLinkTracking.addEventListener('click', () => {
    publish('fit_contact_clicked', { model: document.getElementById('cn-variant-select')?.selectedOptions[0]?.dataset.sku || '' });
  });
  const rentTab = document.getElementById('tab-rent');
  if (rentTab) rentTab.addEventListener('click', () => publish('rent_tab_opened', {}));
  const rentContact = document.querySelector('#pane-rent .text-link');
  if (rentContact) rentContact.addEventListener('click', () => publish('rent_contact_clicked', {}));
  const shopMenu = document.getElementById('cn-shop-menu');
  if (shopMenu) {
    document.addEventListener('click', event => {
      if (!shopMenu.contains(event.target)) shopMenu.open = false;
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && shopMenu.open) {
        shopMenu.open = false;
        shopMenu.querySelector('summary').focus();
      }
    });
  }
  // Product option pills drive the Shopify variant field.
  document.querySelectorAll('[data-cn-variant-choice]').forEach(choice => {
    choice.addEventListener('change', () => {
      const target = document.getElementById('cn-variant-select');
      if (target && choice.checked) { target.value = choice.value; target.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  const productImage = document.getElementById('cn-product-image');
  const thumbnails = document.querySelectorAll('.native-thumbnail');
  const updateImage = (url, alt) => {
    if (!productImage || !url) return;
    productImage.removeAttribute('srcset');
    productImage.src = url;
    productImage.alt = alt || '';
    thumbnails.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.imageUrl === url)));
  };
  thumbnails.forEach(button => button.addEventListener('click', () => updateImage(button.dataset.imageUrl, button.dataset.imageAlt)));
  const contactSuccess = document.querySelector('.native-contact-status--success');
  if (contactSuccess) contactSuccess.focus();
  const contactBody = document.getElementById('ContactForm-body');
  const requestedModel = new URLSearchParams(location.search).get('model');
  if (contactBody && requestedModel && !contactBody.value.trim()) {
    contactBody.value = `Please check whether model ${requestedModel.slice(0, 80)} is a good fit for my home.`;
  }

  const variantSelect = document.getElementById('cn-variant-select');
  if (variantSelect) {
    const buyPrice = document.getElementById('cn-buy-price');
    const buyButton = document.getElementById('cn-buy-submit');
    const buyBox = document.getElementById('buy-box');
    const buyMode = document.getElementById('cn-buy-mode');
    const rentMode = document.getElementById('cn-rent-mode');
    const rentChoice = document.getElementById('cn-rent-choice');
    const rentPanel = document.getElementById('cn-rent-panel');
    const rentForm = document.getElementById('cn-rent-form');
    const rentId = document.getElementById('cn-rent-id');
    const rentMonthly = document.getElementById('cn-rent-monthly');
    const rentSummary = document.getElementById('cn-rent-summary');
    const rentBrief = document.getElementById('cn-rent-brief');
    const rentTerms = document.getElementById('cn-rent-terms');
    const rentTermsWrap = document.getElementById('cn-rent-terms-wrap');
    const rentPending = document.getElementById('cn-rent-pending');
    const stickyBuy = document.querySelector('.sticky-buy');
    const purchaseOnlySections = document.querySelectorAll('[data-cn-buy-only]');
    // Labels come from Theme settings: the rendered button text and data attributes.
    const buyLabel = buyButton.textContent;
    const unavailableLabel = buyButton.dataset.unavailableLabel ?? 'Currently unavailable';

    const modeStorageKey = `cn-purchase-mode:${location.pathname}`;
    let preferredMode = variantSelect.dataset.initialPurchaseMode || null;
    const readSavedMode = () => {
      if (preferredMode) return preferredMode;
      try { return sessionStorage.getItem(modeStorageKey); } catch (_) { return null; }
    };
    const writeSavedMode = mode => {
      preferredMode = mode;
      try { sessionStorage.setItem(modeStorageKey, mode); } catch (_) {}
    };
    if (variantSelect.dataset.initialPurchaseMode) writeSavedMode(variantSelect.dataset.initialPurchaseMode);
    const syncVariantUrl = () => {
      const option = variantSelect.selectedOptions[0];
      if (!option) return;
      const url = new URL(location.href);
      const selectedId = rentMode.checked && !rentChoice.hidden && option.dataset.rentVariantId ? option.dataset.rentVariantId : option.value;
      url.searchParams.set('variant', selectedId);
      history.replaceState({}, '', url);
    };
    const updateMode = () => {
      const showRent = rentMode.checked && !rentChoice.hidden;
      buyBox.hidden = showRent;
      rentPanel.hidden = !showRent;
      if (stickyBuy) stickyBuy.hidden = showRent;
      purchaseOnlySections.forEach(section => { section.hidden = showRent; });
    };
    const syncPurchaseMode = () => {
      const saved = readSavedMode();
      if (!rentChoice.hidden && saved !== 'buy') rentMode.checked = true;
      else buyMode.checked = true;
      updateMode();
    };
    const rememberMode = () => {
      writeSavedMode(rentMode.checked && !rentChoice.hidden ? 'rent' : 'buy');
      updateMode();
      syncVariantUrl();
    };

    const updateVariant = (syncUrl = false) => {
      const option = variantSelect.selectedOptions[0];
      if (!option) return;
      buyPrice.textContent = option.dataset.buyPrice ?? 'Price unavailable';
      buyButton.disabled = option.dataset.buyReady !== 'true';
      buyButton.textContent = buyButton.disabled ? unavailableLabel : buyLabel;
      document.querySelectorAll('[data-cn-variant-choice]').forEach(choice => { choice.checked = choice.value === option.value; });
      const stickyPrice = document.getElementById('cn-sticky-price');
      if (stickyPrice) stickyPrice.textContent = buyPrice.textContent;
      const stickyButton = document.getElementById('cn-sticky-submit');
      if (stickyButton) stickyButton.disabled = buyButton.disabled;
      const sku = document.getElementById('cn-product-sku');
      if (sku) {
        sku.textContent = option.dataset.sku ? `Model: ${option.dataset.sku}` : '';
        sku.hidden = !option.dataset.sku;
      }
      const factsModel = document.getElementById('cn-facts-model');
      if (factsModel) factsModel.textContent = option.dataset.sku || '';
      const fitLink = document.getElementById('cn-fit-link');
      if (fitLink) fitLink.href = `/pages/contact?model=${encodeURIComponent(option.dataset.sku || '')}`;
      updateImage(option.dataset.imageUrl, option.dataset.imageAlt);
      let approvedTermsUrl;
      try {
        approvedTermsUrl = new URL(option.dataset.rentTerms || '', location.href);
      } catch (error) {
        approvedTermsUrl = null;
      }
      const offerVisible = option.dataset.rentVisible === 'true' && Boolean(option.dataset.rentMonthly && option.dataset.rentInitial);
      const rentReady = offerVisible && option.dataset.rentReady === 'true' && Boolean(option.dataset.rentId && option.dataset.rentSummary?.trim() && option.dataset.rentTerms?.startsWith('https://') && approvedTermsUrl && approvedTermsUrl.protocol === 'https:');
      rentChoice.hidden = !offerVisible;
      if (!offerVisible) buyMode.checked = true;
      rentId.value = rentReady ? option.dataset.rentId : '';
      rentMonthly.textContent = offerVisible ? option.dataset.rentMonthly : '';
      rentSummary.textContent = rentReady ? option.dataset.rentSummary : '';
      rentSummary.hidden = !rentReady;
      rentBrief.hidden = !rentReady;
      rentTermsWrap.hidden = !rentReady;
      if (rentReady) rentTerms.href = approvedTermsUrl.href;
      else rentTerms.removeAttribute('href');
      rentForm.hidden = !rentReady;
      rentPending.hidden = rentReady;
      syncPurchaseMode();
      if (syncUrl) syncVariantUrl();
    };
    variantSelect.addEventListener('change', () => updateVariant(true));
    buyMode.addEventListener('change', rememberMode);
    rentMode.addEventListener('change', rememberMode);
    rentForm.addEventListener('submit', event => {
      if (rentForm.hidden || rentPanel.hidden || !rentMode.checked || rentChoice.hidden || !rentId.value || !rentTerms.href) event.preventDefault();
    });
    updateVariant();
    window.addEventListener('pageshow', syncPurchaseMode);
    window.addEventListener('load', () => {
      syncPurchaseMode();
      requestAnimationFrame(syncPurchaseMode);
      setTimeout(syncPurchaseMode, 0);
      setTimeout(syncPurchaseMode, 100);
    });
  }

  const cartForm = document.getElementById('cn-native-cart');
  if (cartForm) {
    const date = document.getElementById('cn-install-date');
    const flexibleDate = document.getElementById('cn-flexible-date');
    const windowSelect = document.getElementById('cn-install-window');
    const status = document.getElementById('cn-preference-status');
    const saveError = status.dataset.cnError ?? 'Could not save yet. Please try again before checkout.';
    const timeField = windowSelect.closest('.field');
    let timePicker;
    const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
    date.min = today;
    const dateField = date.closest('.field');
    const dateTrigger = typeof window.flatpickr === 'function' ? document.createElement('button') : null;
    let datePickerKeyboard = false;
    if (dateTrigger) {
      dateTrigger.type = 'button';
      dateTrigger.id = 'cn-install-date-display';
      dateTrigger.className = 'cn-schedule-input cn-date-trigger';
      dateTrigger.setAttribute('aria-haspopup', 'dialog');
      dateTrigger.setAttribute('aria-controls', 'cn-install-calendar');
      dateTrigger.setAttribute('aria-expanded', 'false');
      const dateLabel = cartForm.querySelector('label[for="cn-install-date"]');
      if (dateLabel) {
        dateLabel.id = 'cn-install-date-label';
        dateLabel.htmlFor = dateTrigger.id;
        dateTrigger.setAttribute('aria-labelledby', `${dateLabel.id} ${dateTrigger.id}`);
      }
      date.parentElement.insertBefore(dateTrigger, date);
    }
    const syncDateTrigger = (_, __, picker) => {
      dateTrigger.textContent = picker.altInput.value || date.placeholder;
    };
    const datePicker = typeof window.flatpickr === 'function' ? window.flatpickr(date, {
      altInput: true,
      altFormat: 'M j',
      altInputClass: 'cn-schedule-input',
      ariaDateFormat: 'F j, Y',
      dateFormat: 'Y-m-d',
      minDate: today,
      disableMobile: true,
      clickOpens: false,
      ignoredFocusElements: [dateTrigger],
      positionElement: date.parentElement,
      onReady: syncDateTrigger,
      onValueUpdate: syncDateTrigger,
      onOpen: () => { timePicker?.close(); dateTrigger.setAttribute('aria-expanded', 'true'); },
      onClose: () => {
        dateTrigger.setAttribute('aria-expanded', 'false');
        if (datePickerKeyboard) dateTrigger.focus({ preventScroll: true });
        datePickerKeyboard = false;
      }
    }) : null;
    if (datePicker?.altInput) {
      // Flatpickr returns focus to this input after selection. Keep it hidden so
      // opening or selecting a date cannot focus a small text field on mobile.
      datePicker.altInput.type = 'hidden';
      document.addEventListener('pointerdown', () => { datePickerKeyboard = false; }, true);
      const openDatePicker = keyboard => {
        datePickerKeyboard = keyboard;
        datePicker.open();
        if (keyboard && datePicker.isOpen) {
          const day = datePicker.calendarContainer.querySelector('.flatpickr-day.selected:not(.flatpickr-disabled)')
            ?? datePicker.calendarContainer.querySelector('.flatpickr-day.today:not(.flatpickr-disabled)')
            ?? datePicker.calendarContainer.querySelector('.flatpickr-day:not(.flatpickr-disabled):not(.hidden)');
          day?.focus({ preventScroll: true });
        }
      };
      dateTrigger.addEventListener('click', event => {
        if (datePicker.isOpen) datePicker.close();
        else openDatePicker(event.detail === 0);
      });
      dateTrigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); openDatePicker(true); }
        if (event.key === 'Escape') datePicker.close();
      });
      datePicker.calendarContainer.addEventListener('keydown', event => {
        if (event.key === 'Tab' && event.shiftKey && event.target.classList.contains('flatpickr-day')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          datePicker.close();
          dateTrigger.focus({ preventScroll: true });
        }
      }, true);
      const dateLabel = cartForm.querySelector('#cn-install-date-label');
      datePicker.calendarContainer.id = 'cn-install-calendar';
      datePicker.calendarContainer.setAttribute('role', 'dialog');
      datePicker.calendarContainer.setAttribute('aria-label', dateLabel?.textContent.trim() ?? 'Preferred date');
    }
    const todayButton = datePicker ? document.createElement('button') : null;
    if (todayButton) {
      todayButton.type = 'button';
      todayButton.className = 'cn-calendar-today';
      todayButton.id = 'cn-calendar-today';
      todayButton.textContent = date.dataset.todayLabel ?? 'Today';
      todayButton.addEventListener('click', () => { datePicker.setDate(today, true); datePicker.close(); });
      datePicker.calendarContainer.appendChild(todayButton);
    }
    const timeTrigger = document.createElement('button');
    timeTrigger.type = 'button';
    timeTrigger.id = 'cn-install-time-toggle';
    timeTrigger.className = 'cn-schedule-input cn-time-trigger';
    timeTrigger.setAttribute('role', 'combobox');
    timeTrigger.setAttribute('aria-haspopup', 'listbox');
    timeTrigger.setAttribute('aria-expanded', 'false');
    timeTrigger.setAttribute('aria-required', 'true');
    timeTrigger.setAttribute('aria-controls', 'cn-install-time-menu');
    const timeLabel = cartForm.querySelector('label[for="cn-install-window"]');
    if (timeLabel) {
      timeLabel.id = 'cn-install-time-label';
      timeLabel.htmlFor = timeTrigger.id;
      timeTrigger.setAttribute('aria-labelledby', timeLabel.id);
    }
    const timeMenu = document.createElement('div');
    timeMenu.id = 'cn-install-time-menu';
    timeMenu.className = 'cn-time-dropdown';
    timeMenu.hidden = true;
    timeMenu.setAttribute('role', 'listbox');
    timeMenu.setAttribute('aria-labelledby', 'cn-install-time-label');
    const timeHeading = document.createElement('p');
    timeHeading.className = 'cn-time-menu-heading';
    timeHeading.textContent = timeLabel?.textContent.trim() ?? 'Preferred time';
    timeMenu.appendChild(timeHeading);
    const timeOptions = document.createElement('div');
    timeOptions.className = 'cn-time-options';
    timeOptions.setAttribute('role', 'presentation');
    timeMenu.appendChild(timeOptions);
    const timeItems = Array.from(windowSelect.options).filter(option => option.value).map((option, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.id = `cn-time-option-${index}`;
      button.className = 'cn-time-option';
      button.tabIndex = -1;
      button.setAttribute('role', 'option');
      button.dataset.timeValue = option.value;
      if (option.value === 'Flexible') button.classList.add('cn-time-option--flexible');
      button.textContent = option.textContent;
      button.addEventListener('mousedown', event => event.preventDefault());
      button.addEventListener('click', () => {
        if (button.disabled || timeTrigger.disabled) return;
        windowSelect.value = option.value;
        windowSelect.dispatchEvent(new Event('change', { bubbles: true }));
        closeTimeMenu();
        timeTrigger.focus();
      });
      timeOptions.appendChild(button);
      return { option, button };
    });
    let activeTime = -1;
    const setActiveTime = index => {
      activeTime = index;
      timeItems.forEach((item, itemIndex) => item.button.classList.toggle('is-active', index === itemIndex));
      if (index >= 0) {
        timeTrigger.setAttribute('aria-activedescendant', timeItems[index].button.id);
        timeItems[index].button.scrollIntoView?.({ block: 'nearest' });
      } else timeTrigger.removeAttribute('aria-activedescendant');
    };
    const closeTimeMenu = () => {
      timeMenu.hidden = true;
      timeTrigger.setAttribute('aria-expanded', 'false');
      timeTrigger.removeAttribute('aria-activedescendant');
    };
    const syncTimeMenu = () => {
      timeTrigger.textContent = windowSelect.selectedOptions[0]?.textContent ?? windowSelect.options[0].textContent;
      timeTrigger.disabled = windowSelect.disabled;
      timeItems.forEach(({ option, button }) => {
        button.disabled = option.disabled || windowSelect.disabled;
        button.setAttribute('aria-disabled', String(button.disabled));
        button.setAttribute('aria-selected', String(option.value === windowSelect.value));
      });
    };
    timePicker = { close: closeTimeMenu };
    windowSelect.parentElement.insertBefore(timeTrigger, windowSelect);
    document.body.appendChild(timeMenu);
    windowSelect.hidden = true;
    windowSelect.required = false;
    const syncAvailableTimes = () => {
      const nowParts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Toronto', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date()).map(part => [part.type, part.value]));
      const currentMinutes = Number(nowParts.hour) * 60 + Number(nowParts.minute);
      Array.from(windowSelect.options).forEach(option => {
        if (option.dataset.minutes !== undefined) option.disabled = date.value === today && Number(option.dataset.minutes) <= currentMinutes;
      });
      if (windowSelect.selectedOptions[0]?.disabled) windowSelect.value = '';
      syncTimeMenu();
    };
    syncAvailableTimes();
    const openTimeMenu = () => {
      if (timeTrigger.disabled) return;
      syncAvailableTimes();
      datePicker?.close();
      timeMenu.hidden = false;
      timeTrigger.setAttribute('aria-expanded', 'true');
      const bounds = timeTrigger.getBoundingClientRect();
      const width = Math.min(312, window.innerWidth - 24);
      timeMenu.style.width = `${width}px`;
      const left = Math.max(12, Math.min(bounds.left, window.innerWidth - width - 12));
      let top = bounds.bottom + 8;
      if (window.innerHeight - bounds.bottom < timeMenu.offsetHeight + 20 && bounds.top > window.innerHeight - bounds.bottom) top = bounds.top - timeMenu.offsetHeight - 8;
      top = Math.max(12, Math.min(top, window.innerHeight - timeMenu.offsetHeight - 12));
      timeMenu.style.left = `${window.scrollX + left}px`;
      timeMenu.style.top = `${window.scrollY + top}px`;
      const selected = timeItems.findIndex(item => item.option.value === windowSelect.value && !item.button.disabled);
      setActiveTime(selected >= 0 ? selected : timeItems.findIndex(item => !item.button.disabled));
    };
    timeTrigger.addEventListener('click', () => timeMenu.hidden ? openTimeMenu() : closeTimeMenu());
    timeTrigger.addEventListener('keydown', event => {
      if (event.key === 'Escape' || event.key === 'Tab') { closeTimeMenu(); return; }
      if (!['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      if (timeMenu.hidden) { openTimeMenu(); return; }
      if (event.key === 'Enter' || event.key === ' ') { timeItems[activeTime]?.button.click(); return; }
      const enabled = timeItems.map((item, index) => item.button.disabled ? -1 : index).filter(index => index >= 0);
      if (!enabled.length) return;
      let index = enabled.indexOf(activeTime);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = enabled.length - 1;
      else index = (index + (['ArrowUp', 'ArrowLeft'].includes(event.key) ? -1 : 1) + enabled.length) % enabled.length;
      setActiveTime(enabled[index]);
    });
    document.addEventListener('mousedown', event => {
      if (!timeMenu.contains(event.target) && !timeTrigger.contains(event.target)) closeTimeMenu();
    });
    window.addEventListener('resize', closeTimeMenu);
    window.addEventListener('scroll', closeTimeMenu);
    windowSelect.addEventListener('change', () => {
      syncTimeMenu();
      timeField?.classList.remove('invalid');
      timeTrigger.removeAttribute('aria-invalid');
    });
    const syncFlexible = () => {
      const flexible = windowSelect.value === 'Flexible';
      date.disabled = flexible;
      date.required = !flexible;
      flexibleDate.disabled = !flexible;
      if (datePicker?.altInput) datePicker.altInput.disabled = flexible;
      if (dateTrigger) dateTrigger.disabled = flexible;
      if (flexible) datePicker?.close();
      if (todayButton) todayButton.disabled = flexible;
      if (flexible) {
        dateField?.classList.remove('invalid');
        dateTrigger?.removeAttribute('aria-invalid');
      }
    };
    windowSelect.addEventListener('change', syncFlexible);
    syncFlexible();
    let saveQueue = Promise.resolve();
    const savePreference = () => {
      dateField?.classList.remove('invalid');
      dateTrigger?.removeAttribute('aria-invalid');
      status.textContent = '';
      status.hidden = true;
      status.dataset.state = 'saving';
      const preferredDate = windowSelect.value === 'Flexible' ? 'Flexible' : date.value;
      const preferredWindow = windowSelect.value;
      saveQueue = saveQueue.catch(() => {}).then(async () => {
        const body = new FormData();
        body.append('attributes[Preferred installation date]', preferredDate);
        body.append('attributes[Preferred installation window]', preferredWindow);
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(cartForm.dataset.updateUrl, {
            method: 'POST',
            body,
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            signal: controller.signal
          });
          if (!response.ok) throw new Error('Cart update failed');
        } finally {
          clearTimeout(timeout);
        }
      });
      saveQueue.then(() => {
        if ((preferredWindow === 'Flexible' || date.value === preferredDate) && windowSelect.value === preferredWindow) {
          status.dataset.state = 'saved';
          status.textContent = '';
          status.hidden = true;
          if (preferredWindow === 'Flexible') publish('cart_flexible_saved', {});
        }
      }).catch(() => {
        if ((preferredWindow === 'Flexible' || date.value === preferredDate) && windowSelect.value === preferredWindow) {
          status.dataset.state = 'error';
          status.textContent = saveError;
          status.hidden = false;
        }
      });
      return saveQueue;
    };
    date.addEventListener('change', () => { syncAvailableTimes(); savePreference(); });
    windowSelect.addEventListener('change', savePreference);
    const checkoutButton = cartForm.querySelector('[name="checkout"]');
    if (checkoutButton && typeof cartForm.requestSubmit === 'function') {
      let resumingCheckout = false;
      let checkoutPending = false;
      cartForm.addEventListener('submit', async event => {
        if (resumingCheckout) return;
        event.preventDefault();
        syncAvailableTimes();
        const missingDate = windowSelect.value !== 'Flexible' && (!date.value || date.value < today);
        if (dateField) dateField.classList.toggle('invalid', missingDate);
        if (missingDate) {
          dateTrigger?.setAttribute('aria-invalid', 'true');
          (dateTrigger ?? date).focus({ preventScroll: true });
          datePicker?.open();
          return;
        }
        const missingTime = !windowSelect.value || windowSelect.selectedOptions[0]?.disabled;
        timeField?.classList.toggle('invalid', missingTime);
        timeTrigger.setAttribute('aria-invalid', String(missingTime));
        if (missingTime) { timeTrigger.focus(); openTimeMenu(); return; }
        if (checkoutPending || !cartForm.reportValidity()) return;
        checkoutPending = true;
        checkoutButton.disabled = true;
        date.readOnly = true;
        if (dateTrigger) dateTrigger.disabled = true;
        windowSelect.disabled = true;
        syncTimeMenu();
        closeTimeMenu();
        datePicker?.close();
        if (datePicker?.calendarContainer) datePicker.calendarContainer.inert = true;
        if (todayButton) todayButton.disabled = true;
        try {
          await savePreference();
        } catch (error) {
          // The form post also carries both cart attributes if the Ajax save fails.
        }
        checkoutButton.disabled = false;
        date.readOnly = false;
        windowSelect.disabled = false;
        syncTimeMenu();
        if (datePicker?.calendarContainer) datePicker.calendarContainer.inert = false;
        syncFlexible();
        checkoutPending = false;
        resumingCheckout = true;
        cartForm.requestSubmit(checkoutButton);
        resumingCheckout = false;
      });
    }
  }
});
